<template>
  <div>
    <el-card>
      <template #header>用户360</template>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="用户ID">
          <el-input v-model.trim="userID" placeholder="请输入用户ID" style="width: 180px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="load">查询</el-button>
        </el-form-item>
      </el-form>

      <el-descriptions v-if="data.user" :column="2" border>
        <el-descriptions-item label="用户ID">{{ data.user.id }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ data.user.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ data.user.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="最近登录IP">{{ data.user.last_login_ip || '-' }}</el-descriptions-item>
        <el-descriptions-item label="最近登录">{{ data.user.last_login_at || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ data.user.created_at || '-' }}</el-descriptions-item>
        <el-descriptions-item label="后台备注" :span="2">{{ data.user.admin_note || '-' }}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions v-if="data.subscription" :column="2" border style="margin-top: 12px;">
        <el-descriptions-item label="会员套餐">{{ data.subscription.plan_code }}</el-descriptions-item>
        <el-descriptions-item label="会员状态">{{ data.subscription.status }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ data.subscription.start_at }}</el-descriptions-item>
        <el-descriptions-item label="到期时间">{{ data.subscription.end_at }}</el-descriptions-item>
      </el-descriptions>

      <el-table :data="data.recent_reports || []" stripe border size="small" style="margin-top: 12px;" v-loading="loading">
        <el-table-column prop="report_id" label="报告ID" min-width="220" show-overflow-tooltip />
        <el-table-column prop="method" label="流派" width="110" />
        <el-table-column prop="created_at" label="时间" min-width="160" />
        <el-table-column prop="summary" label="摘要" min-width="240" show-overflow-tooltip />
      </el-table>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { adminApi } from '../api/admin'

const userID = ref('')
const loading = ref(false)
const data = reactive({ user: null, subscription: null, quota_today: null, recent_reports: [] })

async function load() {
  const id = Number(userID.value || 0)
  if (!id) {
    ElMessage.warning('请输入有效用户ID')
    return
  }
  loading.value = true
  try {
    const res = await adminApi.userProfile360(id)
    data.user = res.user || null
    data.subscription = res.subscription || null
    data.quota_today = res.quota_today || null
    data.recent_reports = res.recent_reports || []
  } catch (e) {
    ElMessage.error(e.message || '查询失败')
  } finally {
    loading.value = false
  }
}
</script>
